export const setValue = (fn: (value: string) => void) => (
  event?: React.FormEvent<HTMLInputElement>
) => {
  if (event) {
    fn(event.currentTarget.value);
  }
};
